'use client';

import { useEffect, useState } from 'react';
import { getWindowTrackerState } from '../utils';
import { EVENT_PAGE_VIEW_SENT } from '../utils/event-names';
import { PageViewData } from '../types';

type UsePageViewContext = () => PageViewData | undefined;

/**
 * Returns the current page view context.
 */
export const usePageViewContext: UsePageViewContext = () => {
  let [context, setContext] = useState<PageViewData>();

  let handlePageViewSent = () => {
    setContext(getWindowTrackerState().pageViewContext);
  };

  useEffect(() => {
    window.addEventListener(EVENT_PAGE_VIEW_SENT, handlePageViewSent);

    return () => {
      window.removeEventListener(EVENT_PAGE_VIEW_SENT, handlePageViewSent);
    };
  }, []);

  return context ?? getWindowTrackerState().pageViewContext;
};
